/* eslint-disable react/react-in-jsx-scope */
import { JobType, PapsService, ParcelStatus, SubTaskStatus } from "generated/graphql";
import { CourseIcon, MadIcon, MsgIcon, NtIcon, TrIcon } from "icons";

export const PackageStatusColorMapping = {
  [ParcelStatus.ToReceive]: "#ba68c8",
  [ParcelStatus.PickFailed]: "#ce0047",
  [ParcelStatus.AwaitingDelivery]: "#999",
  [ParcelStatus.Received]: "#2196f3",
  [ParcelStatus.Dispatched]: "#FF9800",
  [ParcelStatus.OnDelivery]: "#3f51b5",
  [ParcelStatus.Successful]: "#2c9f2c",
  [ParcelStatus.Failed]: "#e83800",
  [ParcelStatus.Cancelled]: "#e53935",
  [ParcelStatus.NotReceived]: "#e53935",
  [ParcelStatus.Archived]: "#ce0047",
  [ParcelStatus.ToReturn]: "#e60000",
  [ParcelStatus.Returned]: "#828282",
  UNASSIGNED: "#f0be04",
  DONE: "#2c9f2c",
};

export const PapsServiceColor = {
  [PapsService.Nt]: "#394fbf",
  [PapsService.Course]: "#f5b417",
  [PapsService.Mad]: "#2f80ed",
  [PapsService.Msg]: "#399ebf",
  [PapsService.Tr]: "#2ba815",
};

export const TasksIconDetail = (service?: PapsService, size?: number, width = 45, height = 41) => {
  switch (service) {
    case PapsService.Msg:
      return <MsgIcon width={width} height={height} />;
    case PapsService.Nt:
      return <NtIcon width={width} height={height} />;
    case PapsService.Course:
      return <MsgIcon width={width} height={height} />;
    case PapsService.Mad:
      return <MadIcon width={width} height={height} />;
    case PapsService.Tr:
      return <TrIcon width={width} height={height} />;

    default:
      break;
  }
};
export const TasksIcon = {
  [PapsService.Nt]: <NtIcon />,
  [PapsService.Mad]: <MadIcon />,
  [PapsService.Course]: <CourseIcon />,
  [PapsService.Msg]: <MsgIcon />,
  [PapsService.Tr]: <TrIcon />,
};

export const TasksService = {
  [PapsService.Nt]: "N. Transport",
  [PapsService.Mad]: "Dedicated Courier",
  [PapsService.Course]: "Course",
  [PapsService.Msg]: "Messaging",
  [PapsService.Tr]: "Paps Tour",
};

export const JobTypeColor = {
  [JobType.Dropoff]: "#ebae23",
  [JobType.Pickup]: "#399ebf",
};

export const TaskStatusColorMapping = {
  [SubTaskStatus.Unassigned]: "#f0be04",
  [SubTaskStatus.Assigned]: "#399ebf",
  [SubTaskStatus.Done]: "#39bf86",
  [SubTaskStatus.Cancelled]: "#f90808f0",
};

export const StatusReason = {
  TO_RECEIVE: "Parcel is waiting to be received at the warehouse.",
  NOT_RECEIVE: "Parcel has been marked as not received.",
  AWAITING_DELIVERY: "Parcel is at the warehouse and waiting to be delivered.",
  TO_BE_ASSIGNED: "Parcel is in a runsheet and is waiting to be assigned to a papser.",
  TO_HAND_OVER: "Parcel has been assigned and waiting to be picked by papser.",
  ON_DELIVERY: "Parcel has been picked up by papser and is on delivery.",
  SUCCESSFULL: "Parcel has been successfully delivered.",
  COMPLETED: "Parcel has been successfully completed.",
  TO_RETURN: "Parcel is waiting to be returned to the initial sender.",
  TO_PICK: "Parcel is waiting to be picked by papser.",
  R_TO_HAND_OVER: "Parcel has been assigned and waiting to be picked by papser.",
  R_TO_BE_ASSIGNED: "Parcel is in a return runsheet and is waiting to be assigned to a papser.",
  ON_RETURN: "Parcel has been picked up by papser and is on return.",
  RETURNED: "Parcel has been returned to 'client_name'",
  PARTIALLY_RECEIVED: "Some parcels from order have been received.",
  PARTIALLY_COMPLETED: "Some parcels from order have been delivered",
  SUCCESSFUL: "Parcel has been succesfully delivered and reconciled",
  DELIVERED: "Parcel has been succesfully delivered by Papser",
  PICK_FAILED: "Parcel is not picked by papser.",
  TO_PREPARE: "A from stock is created and is waiting to be prepared to the warehouse by the agent.",
};

export const getStatusReason = (text: any, status: string, client_company_name: string) => {
  const full_status = `history_${status?.toLowerCase()}`;
  return text?.tracking_history[full_status]?.toString()?.replace("'client_name'", client_company_name || "");
};
